var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnmute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.875,
    cy: 21.875,
    r: 21.875,
    fill: "#747F80"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.273 18.622c0 1.1.05 2.203-.011 3.3-.118 2.1-1.8 3.924-3.877 4.288-2.608.457-5.03-1.169-5.575-3.756a5.114 5.114 0 0 1-.1-1.025c-.01-1.872-.01-3.744-.003-5.615.008-2.45 1.654-4.388 4.069-4.804 2.505-.432 5.05 1.376 5.436 3.889.083.536.074 1.088.085 1.633.013.696.002 1.393.002 2.089l-.026.001Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.548 32.026v-2.925c-.782-.112-1.52-.297-2.213-.631-2.535-1.224-4.045-3.224-4.422-6.016-.126-.935-.08-1.894-.114-2.86h1.952c0 .107-.003.21 0 .312.028.86-.019 1.73.102 2.576.332 2.33 2.271 4.261 4.592 4.67 3.132.553 6.052-1.408 6.686-4.522.114-.559.097-1.146.12-1.72.019-.433.004-.867.004-1.317h1.884c.012.018.027.03.027.042.001 1.047.067 2.095-.105 3.137-.51 3.103-2.954 5.63-6.035 6.23-.182.036-.365.07-.565.107v2.916l-1.913.001Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -41.246,
    y: -41.246,
    width: 126.242,
    height: 126.242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20.623
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6499_4503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6499_4503",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/unmute.9a887045bbf47df04cc7a35d26a4564f.svg";
export { ForwardRef as ReactComponent };